const UserRow = ({ user, companies = [], edit }) => {
  const { name, companyId, active } = user;
  const companyNames = (companyId || [])
    .map(({ _id }) => companies.find(c => `${c._id}` === `${_id}`)?.name)
    .filter(Boolean)
    .join(", ");
  // E-mail, permissões e reset de senha saíram da linha — agora vivem dentro do fluxo de
  // edição (users.jsx), aberto por este único botão.
  return <div className={`user-row ${active === false ? "user-row--inactive" : ""}`}>
    <span>{name}{active === false && <span className="inactive-tag">Inativo</span>}</span>
    <span>{companyNames || "-"}</span>
    <button className="button button-accent" onClick={edit}>Editar</button>
  </div>
}

export default UserRow;
